import axios from "axios";
import { getToken, baseURL} from "../config/index";
import Cookies from "js-cookie";
import { TOAST_MESSAGE_CSS } from "modules/utilities/utility";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SECURITY_TOKEN_FORM } from "../config/env";

const { API_URL_BASE } = baseURL;
const tokenCookie = Cookies.get("token");
const defaultToken = tokenCookie || null;

const api = axios.create({
  baseURL: API_URL_BASE,
  timeout: 50000,
  headers: {
    "X-Custom-Header": "foobar",
  },
});

function isDoctorEndpoint(url) {
  const doctorPatterns = [
    "v4/slots/onboard-user",
    "v4/slots/doctor",
    "v4/doctor_form_slot",
    "getMonthsDiagnosis",
    "v3/slots/",
    "v3/slots/slot-booking",
    "dgReport/result",
    "reschedule-doctor-booking",
    "api/clinic/doctor-book",
    "clinic/view-prescription",
    "next_form",
    "transaction"
  ];

  return doctorPatterns.some((pattern) => url.includes(pattern));
}

api?.interceptors?.request.use(
  (config) => {

    // Determine if it's a doctor-related endpoint
    const isDoctor = isDoctorEndpoint(config.url);

    // Determine the token to use based on whether it's a doctor-related endpoint or not
    const tokenToUse = isDoctor ? SECURITY_TOKEN_FORM  : getToken() || defaultToken;

    // Set the Authorization header with the selected token
    config.headers.Authorization = `Bearer ${tokenToUse}`;

    return config;
  },
  (error) => {
    console.error("Error in API request:", error);
    return Promise.reject(error);
  }
);


api?.interceptors?.response.use(
  (response) => response,
  (error) => {
    if (!error?.response) {
      if (!window.navigator.onLine) {
        toast("You are offline, Please check with internet", TOAST_MESSAGE_CSS);
      }
      console.error("Network error:", error);
    } else if (error?.response?.status === 401) {
      // Only redirect to login if we're not already there
      if (window.location.pathname !== '/login') {
        window.location.href="/login";
        // Clear cookies regardless of current location
        const cookies = Cookies.get();
        Object.keys(cookies).forEach((cookieName) => {
          Cookies.remove(cookieName);
        });
      }
    }
    return Promise.reject(error);
  }
);

export default api;
